type ComparableTeamGroup = {
  sortOrder: number | null;
  createdAt: string;
};

/**
 * Client-side sort order for TeamGroup within a Stage:
 * 1. Groups WITH `sortOrder` come before groups WITHOUT it.
 * 2. Among groups with `sortOrder` — ascending by number.
 * 3. Among groups without `sortOrder` — ascending by `createdAt`.
 *
 * Canonical implementation: imgame-mobile-sdk, lib/src/core/data/mappers/stage/stage_from_json.dart (_compareTeamGroups).
 */
export const compareTeamGroups = (a: ComparableTeamGroup, b: ComparableTeamGroup): number => {
  const aHasSortOrder = a.sortOrder !== null && a.sortOrder !== undefined;
  const bHasSortOrder = b.sortOrder !== null && b.sortOrder !== undefined;

  if (aHasSortOrder !== bHasSortOrder) {
    return aHasSortOrder ? -1 : 1;
  }

  if (aHasSortOrder && bHasSortOrder) {
    return (a.sortOrder as number) - (b.sortOrder as number);
  }

  return new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf();
};
